import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { PnsMacMini } from 'interfaces/pns-mac-mini'

const fetchMacMiniDetail = async (macMiniId: string): Promise<PnsMacMini> => {
  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/mac_minis/${macMiniId}?include=users`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  response = handleErrors(response)
  return response.json()
}

const useMacMiniDetail = (macMiniId?: string) => {
  return useQuery(
    ['mac-mini-detail', macMiniId],
    () => fetchMacMiniDetail(macMiniId!),
    {
      enabled: !!macMiniId,
      staleTime: 30000,
      retry: 2,
    }
  )
}

export default useMacMiniDetail
